import React from "react";
import Icon from "components/icon";
import { useAppTranslation } from "locale/useAppTranslation";

interface StepIndicatorProps {
  currentStep: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => {
  const { t } = useAppTranslation("driverTripCalculator");

  const steps = [
    { num: 1, label: t("step-vehicle-selection") },
    { num: 2, label: t("step-trip-segment") },
    { num: 3, label: t("step-driver-slip") },
  ];

  return (
    <div className="flex items-center gap-1">
      {steps.map((step, idx) => {
        const isCompleted = currentStep > step.num;
        const isActive = currentStep === step.num;

        return (
          <React.Fragment key={step.num}>
            <div
              className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                isActive
                  ? "bg-primary-500 text-white"
                  : isCompleted
                  ? "bg-green-100 text-green-700"
                  : "bg-gray-100 text-gray-500"
              }`}
            >
              {isCompleted ? (
                <Icon name="check" className="h-3.5 w-3.5" />
              ) : (
                <span className="flex h-4 w-4 items-center justify-center rounded-full border border-current text-[10px]">
                  {step.num}
                </span>
              )}
              <span>{step.label}</span>
            </div>
            {idx < steps.length - 1 && (
              <Icon name="chevron-right" className="h-4 w-4 text-gray-400" />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
